<div class="section review-panel">
    <div class="section__header">
        <h2 class="section__name">{{ props['name'] }}</h2>
    </div>
    <ng-container #fieldComponent></ng-container>
</div>
